import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import { LocationSelectors, LocationsByCompanySelectors } from '@core/locations-data';
import { Location } from '@core/locations-types';

@Injectable({
  providedIn: 'root',
})
export class LocationsDescriptionHelper {
  private readonly store = inject(Store);
  private readonly i18n = inject(I18nService);

  private readonly translations = {
    archived: this.i18n.translate('app.locations.archived').toLowerCase(),
  };

  public getLocationNamesValue(locationIds: number[]): string[] {
    return this.store
      .selectSignal(LocationSelectors.byIds(locationIds))()
      .filter(v => v)
      .map(location => this.getLocationName(location));
  }

  public getLocationNames$(locationIds: number[], companyId?: number): Observable<string[]> {
    const locationsSource$ = companyId
      ? this.store.select(LocationsByCompanySelectors.byId(companyId)).pipe(
          filterBoolean,
          map(data => data.locations.filter(location => locationIds.includes(location.id))),
        )
      : this.store.select(LocationSelectors.byIds(locationIds)).pipe(filterBoolean);

    return locationsSource$.pipe(
      filterBoolean,
      take(1),
      map(locations => locations.map(location => this.getLocationName(location)) || []),
    );
  }

  private getLocationName(location: Location): string {
    return location.archivedAt ? `${location.name} (${this.translations.archived})` : location.name;
  }
}
